import { NEW_UI } from '../app/features';
import { splitPlate } from '../domain/passes';
import { GostPlate } from './GostPlate';
import s from './ui.module.css';

/** Russian licence plate drawn as a plate; a non-standard number is shown as is. */
export function Plate({ value }: { value: string }) {
  // The new interface draws plates after GOST; production keeps this one until it switches.
  if (NEW_UI) return <GostPlate value={value} />;
  const { number, region } = splitPlate(value);
  return (
    <span className={s.plate} aria-label={`Госномер ${region ? `${number} ${region}` : number}`}>
      <span className={s.plateNumber}>{number}</span>
      {region && (
        <span className={s.plateRegion} aria-hidden="true">
          {region}
          <span className={s.plateRus}>RUS</span>
        </span>
      )}
    </span>
  );
}

export function WalkerIcon() {
  return (
    <span className={s.walker} aria-hidden="true">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="5" r="2" />
        <path d="M12 8v6M9 21l3-7 3 7M8 11h8" />
      </svg>
    </span>
  );
}

export function LinkIcon() {
  return (
    <span className={`${s.walker} ${s.invite}`} aria-hidden="true">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1" />
        <path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" />
      </svg>
    </span>
  );
}

/** Small inline kind marks for a list line: «на машине» / «пешком». */
export function CarGlyph() {
  return (
    <svg className={s.glyph} role="img" aria-label="На машине" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 17h14v-5l-2-5H7l-2 5v5z" />
      <path d="M5 12h14" />
      <circle cx="8" cy="17" r="1.5" />
      <circle cx="16" cy="17" r="1.5" />
    </svg>
  );
}

export function WalkerGlyph() {
  return (
    <svg className={s.glyph} role="img" aria-label="Пешком" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="5" r="2" />
      <path d="M12 8v6M9 21l3-7 3 7M8 11h8" />
    </svg>
  );
}
